import type { ReactNode } from 'react';

type BadgeTone = 'primary' | 'accent' | 'secondary' | 'neutral';

const TONE_CLASSES: Record<BadgeTone, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
  neutral: 'bg-background-200 text-foreground-700',
};

interface BadgeProps {
  tone?: BadgeTone;
  icon?: string;
  children: ReactNode;
  className?: string;
}

export default function Badge({ tone = 'neutral', icon, children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-label font-semibold whitespace-nowrap ${TONE_CLASSES[tone]} ${className}`}
    >
      {icon ? <i className={`${icon} w-3.5 h-3.5 flex items-center justify-center`} /> : null}
      {children}
    </span>
  );
}